module.exports = "https://cdn.thelire.com/ins/resource/pic_coinstore_x2value@3x.8fe9a966655a2f40b65aac2e8d42438d.png";